import type { GlobalConfig } from '../../../domain/types/configs/company/GlobalConfig';

export const globalConfig: GlobalConfig = {
  purchaseOrderScenario: {
    status: "TO BE CONFIRMED",
    id: "1"
  },
  pickupCounter: 1,
  shipmentCounter: 1,
  warehouseCounter: 1,
  shipmentDisplayField: null,
  shipmentDisplayMode: 'complement' as const,
}; 